// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3DQ6b","notes":"Notes_notes__gQ-vC","note":"Notes_note__22mDi","markdown":"Notes_markdown__1nvgv"};